import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [{
	path: 'intros',
	loadChildren: () => import('@app/intros/module').then(m => m.IntrosModule)
}, {
	path: 'invites',
	loadChildren: () => import('@app/invites/module').then(m => m.InvitesModule)
}, {
	path: 'bill-negotiation',
	loadChildren: () => import('@app/bill-negotiation/module').then(m => m.BillNegotiationModule)
}, {
	path: '**',
	redirectTo: 'intros'
}];

@NgModule({
	imports: [
		RouterModule.forRoot(routes, {
			initialNavigation: 'enabledNonBlocking',
		})
	],
	exports: [
		RouterModule
	]
})
export class AppRoutingModule {
}
